// extracted by mini-css-extract-plugin
module.exports = {"emptyPortfolioContainer":"EmptyPortfolio_emptyPortfolioContainer__2vtu5","blueLink":"EmptyPortfolio_blueLink__11GC3"};